import React from 'react';
import { useEffect, useRef, useState } from 'react';
import { AccordionData } from './accordion';


function AccordionItem({
  data,
  isOpen,
  btnOnClick,
}: {
  data: AccordionData;
  isOpen: boolean;
  btnOnClick: () => void;
}) {
  const contentRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (isOpen) {
      // const contentEl = contentRef.current as HTMLDivElement;

      setHeight(500);
    } else {
      setHeight(0);
    }
  }, [isOpen]);

  var buttonTextToOpen = "Open Sutra";
  var buttonTextToClose = "Close Sutra"
  if (data.language=='zh-Hans'){
    buttonTextToOpen="翻阅经卷";
    buttonTextToClose = "合上经卷";
  }

  return (
    <li className={`accordion-item ${isOpen ? 'open' : ''} ${data.active ? 'active' : ''}`}>
      <div className={`accordion-item-title ${data.active ? 'active' : ''}`}>
      {data.titleEnglish!=""?<h6 className={`accordion-item-title-text ${data.active ? 'active' : ''}`}>{data.titleEnglish}</h6>:null}
      {data.titleChinese!=""?<h6 className={`accordion-item-title-text ${data.active ? 'active' : ''}`}>{data.titleChinese}</h6>:null}
        <p className={`accordion-item-title-time ${data.active ? 'active' : ''}`}>{data.time}</p>
        {data.content != null ? <button className={isOpen?"accordion-item-sutra-opened-btn":"accordion-item-sutra-closed-btn"} onClick={btnOnClick}>
          {isOpen?buttonTextToClose:buttonTextToOpen}
        </button> : null}

      </div>
      <div className="accordion-item-container" style={{ height }} hidden={data.content == <div />}>
        <div ref={contentRef} className="accordion-item-content">
          {data.content}
        </div>
      </div>
    </li>
  );
}

export default AccordionItem;